import { render, staticRenderFns } from "./Testimonial.vue?vue&type=template&id=a2cd66bc&scoped=true&"
import script from "./Testimonial.vue?vue&type=script&lang=ts&"
export * from "./Testimonial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cd66bc",
  null
  
)

export default component.exports